'use client'
import HeaderPreview from "@/components/headers/HeaderPreviewfinal";
import ProductHeader from "@/components/headers/Products/ProductHeader";
import FooterPreview from "@/components/footers/FooterPreview";
import { HRMSProduct } from "@/data/menu";
import { usePathname } from "next/navigation";

// HRMS resource sections that belong to the GetBiz HRMS product. On these the
// GetBiz HRMS secondary product nav (ProductHeader) is shown too, so navigation
// matches the HRMS product pages. Keep in sync with HRMSResources in data/menu.js.
const HRMS_RESOURCE_PREFIXES = [
  "/top-hrms",
  "/interview-questions",
  "/holidays-list-2025",
  "/web-stories",
  "/alternative",
];

export default function RootLayout({ children }) {
  const pathname = usePathname();
  const path = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const isWebStoryDetail = /^\/web-stories\/[^/]+\/?$/.test(path);
  // Show the GetBiz HRMS secondary nav on HRMS resource sections (but not on the
  // full-screen web-story detail pages, which hide all chrome).
  const showHrmsProductNav =
    !isWebStoryDetail &&
    HRMS_RESOURCE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));

  return (
    <>
      <div className="theme-main">
        <div className="page" id="top">
          {!isWebStoryDetail && <nav
            className={
              showHrmsProductNav
                // Match the (hrms) layout: a non-fixed top nav so the secondary
                // ProductHeader renders in flow below it (a fixed nav would sit
                // on top of it and hide it).
                ? "main-nav dark dark-mode -stick-fixed wow-menubar js-transparent fadeInDown animated"
                : "main-nav dark dark-mode stick-fixed wow-menubar js-transparent "
            }
            style={{ background: 'rgba(35, 35, 35) !important' }}
            // , 0.95
          // className="main-nav transparent stick-fixed wow-menubar wch-unset"
          >
            {/* <Header1 links={hometwopage} /> */}
            {/* <Header1Multipage links={menuItems} /> */}
            <HeaderPreview productmenuinmobile={showHrmsProductNav ? HRMSProduct : undefined} />

            {/* <HeaderPreview /> */}
          </nav>
          }
          {/* GetBiz HRMS secondary product nav on HRMS resource sections */}
          {showHrmsProductNav && <ProductHeader data={HRMSProduct} />}
          {children}
        </div>{" "}
      </div>
      {/* <Footer1 /> */}
      {/* <footer className="page-section footer bg-gray-light-1 pb-30"> */}
      {!isWebStoryDetail && <FooterPreview />}
      {/* </footer> */}

    </>
  );
}
